var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-c-data-card",class:_vm.classes},[_c('h4',{staticClass:"cf-c-data-card__heading"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"cf-c-data-card__body"},[_vm._t("default")],2),(_vm.$slots.footer)?_c('div',{staticClass:"cf-c-data-card__footer"},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }